import { render } from "./RModal.vue?vue&type=template&id=5df90cbe"
import script from "./RModal.vue?vue&type=script&lang=js"
export * from "./RModal.vue?vue&type=script&lang=js"

import "./RModal.vue?vue&type=style&index=0&id=5df90cbe&lang=css"
script.render = render

export default script